export default "__VITE_ASSET__479VhuutRPKqW_6Ht6iXzA__";